export default function ResultPage() {
    return (
        <div>
            <h1>Results Page</h1>
        </div>
    );
}